import {inject, PLATFORM,customElement,} from "aurelia-framework";
import {I18N} from 'aurelia-i18n';

@customElement('terms-eightysix-borders')
@inject(I18N)
export class TermsEightysixBorders {

  language: string;
  termsOfUseUrl: string;
  privacyUrl: string;

  constructor(i18n: I18N){
    this.language = i18n.getLocale() == 'es' ? i18n.getLocale() : 'en';
    this.termsOfUseUrl= 'https://86borders.com/terms/acceptable-use-policy.html';
    this.privacyUrl = this.language == 'es' ? 'https://86borders.com/privacy/es/index.html' : 'https://86borders.com/privacy/en/index.html';
  }
}

